import { render, staticRenderFns } from "./CustomerMostVariantReport.vue?vue&type=template&id=517f0f45"
import script from "./CustomerMostVariantReport.vue?vue&type=script&lang=js"
export * from "./CustomerMostVariantReport.vue?vue&type=script&lang=js"
import style0 from "./CustomerMostVariantReport.vue?vue&type=style&index=0&id=517f0f45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports